// import First from "../slider/assets/First.jpg";
import G from "../slider3/assets/G.jpg"
import H from "../slider3/assets/H.jpg"
import I from "../slider3/assets/I.jpg"

export default 
 [
  {
    title: "First Slide",
    description: "This is the first slider Image of our carousel",
    urls: G,
  },
  
  {
    title: "Second Slide",
    description: "This is the second slider Image of our carousel",
    urls: H,
  },
  {
    title: "Third Slide",
    description: "This is the Third slider Image of our carousel",
    urls: I,
  },
  
  
]
